import { isEqual } from 'lodash';
import { UpdateCreatorProfilePayload } from '~/hooks/api/useUpdateCreatorProfile';

import { ProfileFormValues } from './types';

// Simple field mapping for form to payload transformation
const FIELD_MAP: Partial<
  Record<keyof ProfileFormValues, keyof UpdateCreatorProfilePayload>
> = {
  firstName: 'firstName',
  lastName: 'lastName',
  bio: 'biography',
  location: 'location',
  dateOfBirth: 'dateOfBirth',
  gender: 'genderAgency',
  verticals: 'categoryAgency',
  email: 'emailContact',
  webLinks: 'webLinks',
  avatar: 'avatar',
};

// Simple value transformation functions
const transformValue = (key: keyof ProfileFormValues, value: any): any => {
  switch (key) {
    case 'lastName':
    case 'bio':
    case 'dateOfBirth':
    case 'gender':
      return value || null;
    case 'location':
    case 'webLinks':
      return value ? JSON.stringify(value) : null;
    case 'verticals':
      return value?.length ? value.join(',') : null;
    default:
      return value;
  }
};

export const getChangedFields = (
  initialValues: ProfileFormValues,
  currentValues: ProfileFormValues,
): Partial<UpdateCreatorProfilePayload> => {
  const changes: Partial<UpdateCreatorProfilePayload> = {};

  // Check each field for changes
  Object.entries(FIELD_MAP).forEach(([formKey, payloadKey]) => {
    if (payloadKey) {
      const initialValue = initialValues[formKey as keyof ProfileFormValues];
      const currentValue = currentValues[formKey as keyof ProfileFormValues];

      if (!isEqual(initialValue, currentValue)) {
        const transformedValue = transformValue(
          formKey as keyof ProfileFormValues,
          currentValue,
        );
        (changes as any)[payloadKey] = transformedValue;
      }
    }
  });

  return changes;
};
